import { INPUT_METHOD } from '../analytics';
import { TOOLBARS } from './keys';
export var getInputMethodFromParentKeys = function getInputMethodFromParentKeys(parents) {
  var _parents$at;
  return ((_parents$at = parents.at(0)) === null || _parents$at === void 0 ? void 0 : _parents$at.key) === TOOLBARS.INLINE_TEXT_TOOLBAR ? INPUT_METHOD.FLOATING_TB : INPUT_METHOD.TOOLBAR;
};